import type { BreadcrumbItem } from 'components/ui/breadcrumbs';
import { useRouter } from 'next/router';
import { useMemo } from 'react';
import { useLocale } from './useLocale';
import { useI18n } from 'context/i18n';

type useBreadcrumbI18nProps = {
  i18nKeys: { family?: string; target?: string; brand?: string };
};

export function useBreadcrumbI18n(i18nKeys: { [key: string]: string }): BreadcrumbItem[] {
  const { t } = useI18n();
  const {
    query: { target, product, brand },
  } = useRouter();
  const { locale } = useLocale();
  const breacrumbs = useMemo<BreadcrumbItem[]>(() => {
    const bds: BreadcrumbItem[] = [
      {
        name: t('generico', 'breadcrumb.home', '**Home'),
        id: 'home',
        href: `/${locale}`,
      },
    ];

    // para las grids, target y product siempre deben de existir.
    if (target && i18nKeys.target && product && i18nKeys.family) {
      bds.push({
        name: `${t('menu.lateral', i18nKeys.target)} ${t('menu.lateral', `familia.${i18nKeys.family}`)}`,
        id: 'target',
        href: `/${locale}/${target}/${product}`,
      });
    }

    if (brand && i18nKeys.brand) {
      bds.push({
        name: i18nKeys.brand,
        id: 'brand',
        href: `/${locale}/${target}/${product}/${brand}`,
      });
    }
    return bds;
  }, [brand, i18nKeys, locale, product, t, target]);
  return breacrumbs;
}
